<!-- <div class="overlay" *ngIf="loading">
  <img src="assets/icealogo-loader.gif" alt="Image" />
</div> -->
<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="40"
      strokeWidth="3"
    ></mat-progress-spinner>
  </div>
  <form
    class="card-form"
    [formGroup]="sspForm!"
    (ngSubmit)="submitForm()"
    autocomplete="off"
    novalidate
  >
    <div class="blue-top"></div>
    <div class="card-section top-section">
      <!-- only renders if claim isn't theft -->
      <h1><b>Self service Portal</b></h1>
      <h2>Login Authorization</h2>

      <mat-form-field appearance="outline" class="form-select">
        <mat-hint *ngIf="!sspForm!.controls['username'].value">
          <!-- {{regHint}} -->
        </mat-hint>
        <mat-label class="form-select-placeholder-unselected"
          >Username</mat-label
        >
        <input matInput formControlName="username" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['username']">
          {{ formErrors["username"] }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-hint *ngIf="!sspForm!.controls['password'].value">
          <!-- {{regHint}} -->
        </mat-hint>
        <mat-label class="form-select-placeholder-unselected"
          >Password</mat-label
        >
        <input
          matInput
          formControlName="password"
          (blur)="logErrors()"
          type="password"
        />
        <mat-error *ngIf="formErrors['password']">
          {{ formErrors["password"] }}
        </mat-error>
      </mat-form-field>
      <button mat-button type="submit" [disabled]="!sspForm.valid">
        <span class="button-text">Authorize</span>
      </button>
    </div>
  </form>
</div>
